export default __webpack_public_path__ + "static/media/nli-logo.4367da53.svg";